import type { RawPoint } from './periodicChartBuilder';

/** Mild display-only smoothing when daily observations become densely packed.
 * Raw observations remain available to tooltips and axis calculations.
 */
export function pmcDisplayPoints(points: RawPoint[], visibleDays: number): RawPoint[] {
  const strength = Math.max(0, Math.min(1, (visibleDays - 180) / 180));
  if (!strength || points.length < 3) return points;
  const maxGap = 2 * 86400000;
  return points.map((point, index) => {
    const previous = points[index - 1], next = points[index + 1];
    if (!previous || !next || point.x - previous.x > maxGap || next.x - point.x > maxGap) return point;
    return { ...point, y: point.y * (1 - strength / 2) + (previous.y + next.y) * strength / 4 };
  });
}
